const name = window.location.host == 'a.t66b.cn' ? '潍坊华企易办企业服务有限公司' : '潍坊普惠企服企业服务有限公司'
console.log('名字', name);
const sign = window.localStorage.getItem('sign') || ''
export const concealRule = {
    title: '隐私政策',
    content: `<p>您在使用我们的服务过程中，涉及的企业的名称、电话、邮箱、注册地址等信息，是为了联系您、更好的提供服务等用途。我们承诺将涉及的个人信息和隐私进行严格的保密处理。</p>
    <p>我们建立完整的个人隐私保护机制，严格保护您个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。</p>
    <p>您知悉并同意${sign}服务平台会在法律要求或符合平台的相关服务条款协议约定的情况下透露您的个人信息，或者有充分理由相信必须这样做才能：</p>
    <p>（1）满足法律或行政法规的明文规定，或者符合平台网站适用的法律程序；</p>
    <p>（2）符合${sign}服务平台相关服务条款、软件许可使用协议的约定；</p>
    <p>（3）保护平台的权利或财产，以及在紧急情况下保护平台员工或服务的用户或大众的个人安全。</p>
    <p>我们不会未经您的允许将这些信息与第三方共享，本声明已经列出的上述情况除外。</p>
    <p>请您仔细阅读《隐私政策》并确定了我们对您相关信息的处理规则。如您同意此政策，即代表您已同意接收我方推送的短信提醒或会员营销信息。如您有任何疑问，可咨询本平台官方客服。</p>`,
}
//年报申报
export const reportDeferRule = {
    title: '用户协议',
    content: `<p><b>一、导语</b></p>
    <p>
    <b>(一)【审慎阅读】</b>你在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。
    <span style="text-decoration: underline;"><b>免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如你对协议有任何疑问，可向客服咨询。</b></span>
    </p>
    <p>
    <b>(二)【签约动作】</b>当你按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后或以其他方式选择接受本协议或直接使用了本协议相关服务，即表示你已充分阅读、理解并接受本协议的全部内容，并与我司（${sign}年报助手平台及${name}）达成一致，成为我司及${sign}年报助手平台“用户”。
    <span style="text-decoration: underline;"><b>阅读本协议的过程中，如果你不同意本协议或其中任何条款约定，你应立即停止注册程序。</b></span>
    </p>
    <p><b>二、定义</b></p>
    <p>(一)【我司】我司指研发并提供${sign}年报助手平台的${name}。</p>
    <p>(二)【用户（以下或称为“你”）】用户指注册为${sign}年报助手平台用户并购买服务的主体，
    <span style="text-decoration: underline;"><b>目前我司仅向中国境内注册成立的个体工商户提供服务。</b></span>
    </p>
    <p><b>三、协议范围</b></p>
    <p>(一)【平等主体】本协议由你与我司共同缔结，本协议对你与我司均具有合同效力。你已充分阅读、理解并接受本协议的全部内容。本协议将对我司向你的企业提供服务事宜形成具有法律约束力的文件。</p>
    <p>(二)【补充协议】由于互联网高速发展，你与我司签署的本协议列明的条款并不能完整罗列并覆盖你与我司所有权利与义务，现有的约定也不能保证完全符合未来发展的需求，因此《隐私协议》等相关协议以及规则/规范均为本协议的补充协议，与本协议不可分割且具有同等法律效力，若你使用本服务，视为你同意上述补充协议。</p>
    <p><b>四、服务内容及使用规范</b></p>
    <p>(一)【服务概况】你可以选择购买使用${sign}服务平台提供的以下服务：服务项目一：2023年度工商年报代申报；服务项目二：2023年度及2024年度工商年报代申报。
    <span><b>您知晓，根据《个体工商户年度报告暂行办法》的规定，2023年度工商年报的申报期间为2024年1月-6月，2024年度工商年报的申报期间为2025年1月-6月。</b></span>
    </p>
    <p>(二)【准备工作】选择相应服务并付款后，我司客服会在年报的申报期间及时联系您沟通年报申报服务事宜。你需要按要求准备好对应服务所需要的相关资料提交给我司。我司会对这些材料进行审核和整理，并根据企业的情况与需求报送需要报送的文件。</p>
    <p>(三)【企业工商年报代报服务提报说明】你提交年报报送资料后，我司将在20个工作日内完成年报报送，报送成功的标志是你的年报信息在“全国企业信用信息公示系统”中公示或在辖区市场监管部门网站公示。付款后代报送服务非因用户原因（如拒绝接听我司工作时间段
    <b>（工作日的上午8:30-12:00，下午14:00-21:00）</b>联系电话、拒绝提供应当提供的报送信息、提供虚假或错误的信息）导致的不成功支持全额退款；如因不可抗力无法办理的，我司将向你全额退还代报费用。
    <b>在年报报送成功前，你有权随时要求停止报送，扣除人工费用（人工费用为不低于150元/每年度年报代报服务）后退款。在20个工作日期满未能办结的，我司将根据你的意见或者继续办理或扣除人工费用后退款。</b>
    你接受退款或选择继续办理则意味着你同意不追究我司因在承诺时间内未能办结的任何责任。年报报送成功或我司向你全额退款即意味着你与我司委托代理关系终止。
    </p>
    <p>
    <p><b>五、特别说明</b></p>
    <p>(一)【委托代理】若你支付完毕服务费用，即表示你委托我司代你办理你委托的服务事宜，我司将通过网络在线方式为你提供你委托的服务。</p>
    <p>(二)【重点说明】你知悉，按照《企业信息公示暂行条例》、《个体工商户年度报告暂行办法》等法规文件，报送年报是你的法定义务。
   <b>你也知悉，通过市场监督管理部门渠道报送年报、年报补充报送是免费的，通过我司代办你需向我司支付代理服务费用。代理服务费用是我司为你提供服务而收取的服务费。</b>
   代理服务费用的金额以我司通过网页向你公示的价格为准。
    </p>
    <p>(三)【资料说明】你知悉，我司接受你的委托为你办理代理服务需要你按照规定提供包括但不限于法定代表人或负责人身份证、手机号、经营状况等资料，你应当保证资料的真实性、完整性、合法性。我司依据本协议，根据你企业(含个体户)管辖地市场监督管理部门的规定，及时为你办理代理服务。</p>
    <p>(四)【服务电话】我司受理你的委托后，将忠实履行代理义务。我司为你提供人工电话服务，服务电话400-998-7083 你可在工作时间段
    <b>（工作日的上午8:30-12:00，下午14:00-21:00）</b>
    通过该电话咨询业务、了解进程、反映问题、进行投诉、反馈异议等，我是将及时进行处理。
    </p>
    <p>(五)【保密措施】我司承诺,你提交的资料及填写的相关信息.我司将采取严格的保密措施仅用于办理你的委托事宜及与你本人联系。未经你同意，不向任何第三方提供。关于隐私相关的具体约定，见《隐私协议》。</p>
    <p>(六)【名誉保护】在代理服务期间，如我司未违背本协议约定，你不得向任何第三方发布、提供有损我司利益、名誉的信息，否则我司有权追究你的法律责任。</p>
    <p>(七)【用户授权】如你同意此协议，即代表你已同意接收我方推送的短信提醒或会员营销信息。</p>
    <p>(八 )【用户承诺】你应当基于合法、正当的目的使用${sign}服务平台提供的服务，不得滥用任何服务及/或信息 ，否则应自行承担相应法律责任，如由此造成${sign}服务平台损失的，用户还应当予以赔偿。</p>
    <p>(九)本《协议》未明确列出的事项，${sign}服务平台保有最终解释权。请在使用时咨询客服。</p>
    <p><b>六、用户的违约及处理</b></p>
    <p>(一) 违约的认定：</p>
    <p>1.使用${sign}年报助手平台服务时违反有关法律法规规定的；</p>
    <p>2.违反本协议约定的；</p>
    <p><b>3.付款后拒绝接听我司在工作时段的联系电话、拒绝提供应当提供的报送信息、提供虚假或错误的信息。</b></p>
    <p>(二)【违反约定】用户同意保障和维护${sign}服务平台及其他用户的利益，如因用户违反有关法律、法规或本《协议》项下的任何条款而给${sign}服务平台或任何其他第三者造成损失，用户同意承担由此造成的损害赔偿责任。</p>
    <p>(三)【纠纷处理】用户和本平台产生纠纷的，双方应友好协商解决，协商不成的，可向杭州市滨江区人民法院，提起诉讼。双方同意，不以任何方式侵害对方的商誉、名誉等，否则，任何一方均可追究对方的法律责任。</p>
    <p><b>七、免责声明</b></p>
    <p>(一)我司对于下述原因导致的本合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我司无需为此承担任何责任：</p>
    <p>1.我司已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
    <p>2.因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令、疫情等不可抗力因素。</p>
    <p>3.基础运营商或主管部门故障、调整导致之影响。</p>
    <p>4.因政府管制而造成的暂时性关闭、服务调整等。</p>
    <p><b>八、服务终止</b></p>
    <p>(一)【终止的情形】本服务可能会因为下述情形终止：  </p>
    <p>1.我司变更本服务内容而你明示不愿接受变更事项的。</p>
    <p>2.你明示不愿继续使用我司服务，且符合我司终止服务条件的。</p>
    <p>3.你违反本协议约定，我司依据违约条款终止本协议的。</p>
    <p><b>九、知识产权</b></p>
    <p>(一)你不得恶意申请和注册与我司相同或近似的商标、名称、标识、标志、微信公众号、域名、网页等，用于开展与我司实质相同或近似的业务。</p>
    <p><b>十、通知与送达</b></p>
    <p>(一)【通知实时关注】我司根据你提供的任一联系方式送达各类通知，而此类通知的内容可能对你的权利义务产生重大的有利或不利影响，请你务必及时关注。</p>
    <p>(二)【通知的送达】本协议签订或履行过程中，我司向你通过书面形式发送通知，书面通知形式包括但不限于向你发送电子邮件、手机短信、微信消息和传真等电子方式，在采用电子方式进行通知的情况下，发送当日即视为送达。</p>
    <p>(三)【联系方式实时更新】你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不正确，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由你自行承担由此可能产生的法律后果。</p>
    `,
}

//年报补报
export const reportRule = {
    title: '用户协议',
    content: `<p>
   <p><b> 一、导语</b></p>
(一)【审慎阅读】你在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如你对协议有任何疑问，可向客服咨询。
(二)【签约动作】当你按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后或以其他方式选择接受本协议或直接使用了本协议相关服务，即表示你已充分阅读、理解并接受本协议的全部内容，并与我司（${sign}年报助手平台及${name}）达成一致，成为我司及${sign}年报助手平台“用户”。阅读本协议的过程中，如果你不同意本协议或其中任何条款约定，你应立即停止注册程序。
<p><b>二、定义</b></p>
(一)【我司】我司指研发并提供${sign}年报助手平台的${name}。
(二)【用户（以下或称为“你”）】用户指注册为${sign}年报助手平台用户并购买服务的主体，目前我司仅向中国境内注册成立的个体工商户提供服务。
<p><b>三、协议范围</b></p>
(一)【平等主体】本协议由你与我司共同缔结，本协议对你与我司均具有合同效力。你已充分阅读、理解并接受本协议的全部内容。本协议将对我司向你的企业提供服务事宜形成具有法律约束力的文件。
(二)【补充协议】由于互联网高速发展，你与我司签署的本协议列明的条款并不能完整罗列并覆盖你与我司所有权利与义务，现有的约定也不能保证完全符合未来发展的需求，因此《隐私协议》等相关协议以及规则/规范均为本协议的补充协议，与本协议不可分割且具有同等法律效力，若你使用本服务，视为你同意上述补充协议。
<p><b>四、服务内容及使用规范</b></p>
(一)【服务概况】你可以选择购买使用${sign}服务平台提供的以下服务：企业工商年报代报服务（适用于当年1月-6月代申报上一年度年报）或企业工商年报代补报（应报未报年报补报）服务。请注意，目前我司仅向中国境内注册成立的个体工商户提供服务。
(二)【准备工作】选择相应服务并付款后，你需要按要求准备好对应服务所需要的相关资料提交给我司。我司会对这些材料进行审核和整理，并根据企业的情况与需求报送需要报送的文件。
(三)【企业工商年报代报服务提报说明】你提交年报报送资料后，我司将在20个工作日内完成年报报送，报送成功的标志是你的年报信息在“全国企业信用信息公示系统”中公示或在辖区市场监管部门网站公示。付款后代报送服务非因用户原因（如拒绝接听我司工作时间段（工作日的上午8:30-12:00，下午14:00-21:00）联系电话、拒绝提供应当提供的报送信息、提供虚假或错误的信息）导致的不成功支持全额退款；如因不可抗力无法办理的，我司将向你全额退还代报费用。在年报报送成功前，你有权随时要求停止报送，扣除人工费用（150元）后退款。在20个工作日期满未能办结的，我司将根据你的意见或者继续办理或扣除人工费用后退款。你接受退款或选择继续办理则意味着你同意不追究我司因在承诺时间内未能办结的任何责任。年报报送成功或我司向你全额退款即意味着你与我司委托代理关系终止。
(四)【企业工商年报代补报服务提报说明】如您未能在法律规定的期限（每年的6月30日前）内未报送年报的，可委托我司代为补报年报。你提交年报补充报送资料后，我司将在20个工作日内完成年报补充报送，补充报送的标志是你的年报信息在“全国企业信用信息公示系统”中公示或在辖区市场监管部门网站公示。为保障年报数据的准确性，本服务中我司仅为您代补报最近三个完整会计年度的年报。企业工商年报代补报服务不负责处理因你未能及时报送年报而导致的企业工商经营异常状态。付款后年报代补报服务非因用户原因（如拒绝接听我司工作时间段（工作日的上午8:30-12:00，下午14:00-21:00）联系电话、拒绝提供应当提供的报送信息、提供虚假或错误的信息）导致的不成功支持全额退款；如因不可抗力无法办理的，我司将向你全额退还代报费用。在年报补报成功前，你有权随时要求停止报送，扣除人工费用（150元）后退款。在20个工作日期满未能办结的，我司将根据你的意见或者继续办理或扣除人工费用后退款。你接受退款或选择继续办理则意味着你同意不追究我司因在承诺时间内未能办结的任何责任。年报报送成功或我司向你全额退款即意味着你与我司委托代理关系终止。
<p><b>五、特别说明</b></p>
(一)【委托代理】若你支付完毕服务费用，即表示你委托我司代你办理你委托的服务事宜，我司将通过网络在线方式为你提供你委托的服务。
(二)【重点说明】你知悉，按照《企业信息公示暂行条例》、《个体工商户年度报告暂行办法》等法规文件，报送年报是你的法定义务。你也知悉，通过市场监督管理部门渠道报送年报、年报补充报送是免费的，通过我司代办你需向我司支付代理服务费用。代理服务费用是我司为你提供服务而收取的服务费。代理服务费用的金额以我司通过网页向你公示的价格为准。
(三)【资料说明】你知悉，我司接受你的委托为你办理代理服务需要你按照规定提供包括但不限于法定代表人或负责人身份证、手机号、经营状况等资料，你应当保证资料的真实性、完整性、合法性。我司依据本协议，根据你企业(含个体户)管辖地市场监督管理部门的规定，及时为你办理代理服务。
(四)【期限要求】因年报的报送截止时间为每年的6月30日，为此6月28日以后的年报代报委托，存在6月30日之前报送不成功的风险，我司不为此承担任何责任。6月28日以后的年报代报委托，6月30日之前报送不成功的我司将为您提供年报补报服务。
(五)【服务电话】我司受理你的委托后，将忠实履行代理义务。我司为你提供人工电话服务，服务电话400-188-5167 你可在工作时间段（工作日的上午8:30-12:00，下午14:00-21:00）通过该电话咨询业务、了解进程、反映问题、进行投诉、反馈异议等，我是将及时进行处理。
(六)【保密措施】我司承诺,你提交的资料及填写的相关信息.我司将采取严格的保密措施仅用于办理你的委托事宜及与你本人联系。未经你同意，不向任何第三方提供。关于隐私相关的具体约定，见《隐私协议》。
(七)【名誉保护】在代理服务期间，如我司未违背本协议约定，你不得向任何第三方发布、提供有损我司利益、名誉的信息，否则我司有权追究你的法律责任。
(八)【用户授权】如你同意此协议，即代表你已同意接收我方推送的短信提醒或会员营销信息。
(九)【用户承诺】你应当基于合法、正当的目的使用${sign}服务平台提供的服务，不得滥用任何服务及/或信息 ，否则应自行承担相应法律责任，如由此造成${sign}服务平台损失的，用户还应当予以赔偿。
(十)本《协议》未明确列出的事项，${sign}服务平台保有最终解释权。请在使用时咨询客服。
<p><b>六、用户的违约及处理</b></p>
(一) 违约的认定：
1.使用${sign}年报助手平台服务时违反有关法律法规规定的；
2.违反本协议约定的；
3.付款后拒绝接听我司在工作时段的联系电话、拒绝提供应当提供的报送信息、提供虚假或错误的信息。
(二)【禁止性信息】你在使用${sign}年报助手平台服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的商品、服务或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：
1.违反国家法律法规禁止性规定的；
2.政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
3.危害国家安全、泄露国家秘密的；
4.欺诈、虚假、不准确或存在误导性的；
5.侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
6.侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
7.其他违背社会公共利益或公共道德的。
(三)【违反约定】用户同意保障和维护${sign}服务平台及其他用户的利益，如因用户违反有关法律、法规或本《协议》项下的任何条款而给${sign}服务平台或任何其他第三者造成损失，用户同意承担由此造成的损害赔偿责任。
(四)【纠纷处理】用户和本平台产生纠纷的，双方应友好协商解决，协商不成的，可向潍坊滨海经济技术开发区人民法院提起诉讼。双方同意，不以任何方式侵害对方的商誉、名誉等，否则，任何一方均可追究对方的法律责任。
<p><b>七、免责声明</b></p>
(一)我司对于下述原因导致的本合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我司无需为此承担任何责任：
1.我司已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
2.因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令、疫情等不可抗力因素。
3.基础运营商或主管部门故障、调整导致之影响。
4.因政府管制而造成的暂时性关闭、服务调整等。
<p><b>八、服务终止</b></p>
(一)【终止的情形】本服务可能会因为下述情形终止：
1.我司变更本服务内容而你明示不愿接受变更事项的。
2.你明示不愿继续使用我司服务，且符合我司终止服务条件的。
3.你违反本协议约定，我司依据违约条款终止本协议的。
<p><b>九、知识产权</b></p>
(一)你不得恶意申请和注册与我司相同或近似的商标、名称、标识、标志、微信公众号、域名、网页等，用于开展与我司实质相同或近似的业务。
<p><b>十、通知与送达</b></p>
(一)【通知实时关注】我司根据你提供的任一联系方式送达各类通知，而此类通知的内容可能对你的权利义务产生重大的有利或不利影响，请你务必及时关注。
(二)【通知的送达】本协议签订或履行过程中，我司向你通过书面形式发送通知，书面通知形式包括但不限于向你发送电子邮件、手机短信、微信消息和传真等电子方式，在采用电子方式进行通知的情况下，发送当日即视为送达。
(三)【联系方式实时更新】你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不正确，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由你自行承担由此可能产生的法律后果。
    </p>
    `,
}

//企业注销
export const signOutRule = {
    title: '用户协议',
    content: `<p>
   <p><b> 一、导语</b></p>
(一)【审慎阅读】你在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如你对协议有任何疑问，可向客服咨询。
(二)【签约动作】当你按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后或以其他方式选择接受本协议或直接使用了本协议相关服务，即表示你已充分阅读、理解并接受本协议的全部内容，并与我司（${sign}服务平台及${name}）达成一致，成为我司及${sign}服务平台“用户”。阅读本协议的过程中，如果你不同意本协议或其中任何条款约定，你应立即停止注册程序。
<p><b>二、定义</b></p>
(一)【我司】我司指研发并提供${sign}服务平台的${name}。
(二)【用户（以下或称为“你”）】用户指注册为${sign}服务平台用户并购买服务的主体，目前我司仅向中国境内注册成立的个体工商户提供服务。
<p><b>三、协议范围</b></p>
(一)【平等主体】本协议由你与我司共同缔结，本协议对你与我司均具有合同效力。你已充分阅读、理解并接受本协议的全部内容。本协议将对我司向你的企业提供服务事宜形成具有法律约束力的文件。
(二)【补充协议】由于互联网高速发展，你与我司签署的本协议列明的条款并不能完整罗列并覆盖你与我司所有权利与义务，现有的约定也不能保证完全符合未来发展的需求，因此《隐私协议》等相关协议以及规则/规范均为本协议的补充协议，与本协议不可分割且具有同等法律效力，若你使用本服务，视为你同意上述补充协议。
<p><b>四、服务内容及使用规范</b></p>
(一)【服务概况】你可以选择购买使用${sign}服务平台提供的以下服务：企业注销服务。
(二)【准备工作】选择相应服务并付款后，你需要按要求准备好对应服务所需要的相关资料提交给我司指定的服务商。服务商会对这些材料进行审核和整理，并根据企业的情况与需求报送需要报送的文件。你同意授权我司包括但不限于营业执照补办，公章补刻等业务办理必须材料，业务办理完成后，我司根据你的要求将办理材料销毁或者回寄。
(三)【企业注销服务提报说明】你提交企业注销资料后，我司将在30个工作日内完成企业注销资料提交，报送成功的标志是你的企业在“全国企业信用信息公示系统”中公示注销或辖区市场监管部门出具准予注销通知。付款后企业注销服务非因用户原因（如拒绝接听我司工作时间段（工作日的上午8:30-12:00，下午14:00-18:00）联系电话、拒绝提供应当提供的报送信息、提供虚假或错误的信息、付款后主动要求停止注销服务）导致的不成功支持全额退款；如因不可抗力无法办理的，我司将向你全额退还费用。在企业注销完成前，你有权随时要求停止提交，扣除人工费用（收集资料开始前全额退款，收集资料开始后根据服务进度扣除150元至300元）后退款。在30个工作日（前提为不需要处理工商、税务异常）未能办结的，我司将根据你的意见或者继续办理或扣除人工费用后退款。你接受退款或选择继续办理则意味着你同意不追究我司因在承诺时间内未能办结的任何责任。企业注销成功或我司向你全额退款即意味着你与我司委托代理关系终止。
<p><b>五、特别说明</b></p>
(一)【委托代理】若你支付完毕服务费用，即表示你委托我司代你办理你委托的服务事宜，我司将通过网络在线方式为你提供你委托的服务。
(二)【重点说明】你知悉，通过我司代办你需向我司支付代理服务费用，代理服务费用是我司为你提供服务而收取的服务费。代理服务费用的金额以我司通过网页向你公示的价格为准。
(三)【资料说明】你知悉，我司接受你的委托为你办理代理服务需要你按照规定提供包括但不限于法定代表人或负责人身份证、手机号、经营状况等资料，你应当保证资料的真实性、完整性、合法性。我司依据本协议，根据你企业(含个体户)管辖地市场监督管理部门的规定，及时为你办理代理服务。
(四)【服务成本】你确认，在购买本服务之前，你已经过考虑并确定需要进行个体户工商登记注销。购买服务后非我司原因要求解除本协议并退款的，我司可按照以下原则扣除人工成本费用：
1、开始收集个体户工商登记注销资料前要求解除本协议的，全额退款；
2、开始收集个体户工商登记注销资料后要求解除本协议的，根据服务进度扣除150至300元人工成本费用。
(五)【清税证明】如需我司同时处理工商税务违法的，我司有权另行收取服务费用200元。
(六)【违法处理】在企业注销的办理过程中，由于你的企业在以往经营过程中因工商违法、未按要求报税、欠税等原因导致需要缴纳罚款、补交税款、缴纳滞纳金等违法行为处理的，由你自行处理及缴纳，我司可以进行专业指导。需要我司安排人员提供违法行为处理的人工服务的，我司有权另行收取服务费用。由于你拒绝支付违法行为处理的罚款、欠税、滞纳金及人工服务费用导致注销无法完成的，我司同意按照本协议五（四）的退款规则进行退款并解除本协议。
(七)【服务电话】我司受理你的委托后，将忠实履行代理义务。我司为你提供人工电话服务，服务电话400-188-5167 你可在工作时间段（工作日的上午8:30-12:00，下午14:00-18:00）通过该电话咨询业务、了解进程、反映问题、进行投诉、反馈异议等，我是将及时进行处理。
(八)【保密措施】我司承诺,你提交的资料及填写的相关信息.我司将采取严格的保密措施仅用于办理你的委托事宜及与你本人联系。未经你同意，不向任何第三方提供。关于隐私相关的具体约定，见《隐私协议》。
(九)【名誉保护】在代理服务期间，如我司未违背本协议约定，你不得向任何第三方发布、提供有损我司利益、名誉的信息，否则我司有权追究你的法律责任。
(十)【用户授权】如你同意此协议，即代表你已同意接收我方推送的短信提醒或会员营销信息。
(十一)【用户承诺】你应当基于合法、正当的目的使用${sign}服务平台提供的服务，不得滥用任何服务及/或信息 ，否则应自行承担相应法律责任，如由此造成${sign}服务平台损失的，用户还应当予以赔偿。
(十二)本《协议》未明确列出的事项，${sign}服务平台保有最终解释权。请在使用时咨询客服。
<p><b>六、用户的违约及处理</b></p>
(一) 违约的认定：
1.使用${sign}服务平台服务时违反有关法律法规规定的；
2.违反本协议约定的；
3.付款后拒绝接听我司在工作时段的联系电话、拒绝提供应当提供的报送信息、提供虚假或错误的信息。
(二)【禁止性信息】你在使用${sign}服务平台服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的商品、服务或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：
1.违反国家法律法规禁止性规定的；
2.政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
3.危害国家安全、泄露国家秘密的；
4.欺诈、虚假、不准确或存在误导性的；
5.侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
6.侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
7.其他违背社会公共利益或公共道德的。
(三)【违反约定】用户同意保障和维护${sign}服务平台及其他用户的利益，如因用户违反有关法律、法规或本《协议》项下的任何条款而给${sign}服务平台或任何其他第三者造成损失，用户同意承担由此造成的损害赔偿责任。
(四)【纠纷处理】用户和本平台产生纠纷的，双方应友好协商解决，协商不成的，可向我司所在地人民法院，提起诉讼。双方同意，不以任何方式侵害对方的商誉、名誉等，否则，任何一方均可追究对方的法律责任。
<p><b>七、免责声明</b></p>
(一)我司对于下述原因导致的本合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我司无需为此承担任何责任：
1.我司已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
2.因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令、疫情等不可抗力因素。
3.基础运营商或主管部门故障、调整导致之影响。
4.因政府管制而造成的暂时性关闭、服务调整等。
<p><b>八、服务终止</b></p>
(一)【终止的情形】本服务可能会因为下述情形终止：
1.我司变更本服务内容而你明示不愿接受变更事项的。
2.你明示不愿继续使用我司服务，且符合我司终止服务条件的。
3.你违反本协议约定，我司依据违约条款终止本协议的。
<p><b>九、知识产权</b></p>
(一)你不得恶意申请和注册与我司相同或近似的商标、名称、标识、标志、微信公众号、域名、网页等，用于开展与我司实质相同或近似的业务。
<p><b>十、通知与送达</b></p>
(一)【通知实时关注】我司根据你提供的任一联系方式送达各类通知，而此类通知的内容可能对你的权利义务产生重大的有利或不利影响，请你务必及时关注。
(二)【通知的送达】本协议签订或履行过程中，我司向你通过书面形式发送通知，书面通知形式包括但不限于向你发送电子邮件、手机短信、微信消息和传真等电子方式，在采用电子方式进行通知的情况下，发送当日即视为送达。
(三)【联系方式实时更新】你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不正确，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由你自行承担由此可能产生的法律后果。
    </p>
    `,
}

export const mapRule = {
    title: '${sign}地图标注服务协议',
    content: `<p>您在使用我们的服务过程中，涉及的企业的名称、电话、邮箱、注册地址等信息，是为了联系您、更好的提供服务等用途。我们承诺将涉及的个人信息和隐私进行严格的保密处理。</p>
    <p>我们建立完整的个人隐私保护机制，严格保护您个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。</p>
    <p>您知悉并同意${sign}服务平台会在法律要求或符合平台的相关服务条款协议约定的情况下透露您的个人信息，或者有充分理由相信必须这样做才能：</p>
    <p>（1）满足法律或行政法规的明文规定，或者符合平台网站适用的法律程序；</p>
    <p>（2）符合${sign}服务平台相关服务条款、软件许可使用协议的约定；</p>
    <p>（3）保护平台的权利或财产，以及在紧急情况下保护平台员工或服务的用户或大众的个人安全。</p>
    <p>我们不会未经您的允许将这些信息与第三方共享，本声明已经列出的上述情况除外。</p>
    <p>请您仔细阅读《隐私政策》并确定了我们对您相关信息的处理规则。如您同意此政策，即代表您已同意接收我方推送的短信提醒或会员营销信息。如您有任何疑问，可咨询本平台官方客服。</p>`
}

//报税
export const privacyRule = {
    title: '用户协议',
    content: `
    <p>
 <p><b> 一、导语</b></p>
(一)【审慎阅读】你在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如你对协议有任何疑问，可向客服（电话400-188-5167）咨询。
(二)【签约动作】当你按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后或以其他方式选择接受本协议或直接使用了本协议相关服务，即表示你已充分阅读、理解并接受本协议的全部内容，并与我司（${sign}税务申报平台及${name}）达成一致，成为我司及${sign}税务申报平台“用户”。阅读本协议的过程中，如果你不同意本协议或其中任何条款约定，你应立即停止注册程序。
<p><b>二、定义</b></p>
(一)【我司】我司指研发并提供${sign}税务申报平台的${name}。
(二)【用户（以下或称为“你”）】用户指注册为${sign}税务申报平台用户并购买服务的主体。
<p><b>三、协议范围</b></p>
(一)【平等主体】本协议由你与我司共同缔结，本协议对你与我司均具有合同效力。你已充分阅读、理解并接受本协议的全部内容。本协议将对我司向你的企业提供服务事宜形成具有法律约束力的文件。
(二)【补充协议】由于互联网高速发展，你与我司签署的本协议列明的条款并不能完整罗列并覆盖你与我司所有权利与义务，现有的约定也不能保证完全符合未来发展的需求，因此《隐私协议》等相关协议以及规则/规范均为本协议的补充协议，与本协议不可分割且具有同等法律效力，若你使用本服务，视为你同意上述补充协议。
<p><b>四、服务内容及使用规范</b></p>
(一)【服务概况】你可以选择购买使用${sign}服务平台提供的以下服务：企业税务登记代办服务、个体户税收定期定额征收审批代办服务、企业税务申报代报服务。请注意，目前我司仅向中国境内注册成立的个体工商户提供服务。
(二)【准备工作】选择服务并付款后，你需要按要求准备好对应服务所需要的全部资料提交给我司指定服务人员。我司会对这些材料进行审核和整理，并根据税务部门的要求报送相关数据与文件。
(三)【企业税务登记代办服务】企业税务登记代办服务是指我司接受你的委托，为一家个体工商户完成向税务机关申报办理税务登记服务。
(四)【个体户税收定期定额征收审批代办服务】个体户税收定期定额征收审批代办服务是指我司接受你的委托，为一家个体工商户完成向税务机关申报办理个体工商户税收定期定额申报审批的服务。
(五)【企业税务申报代报服务提报说明】税务申报代理服务是一种专业的财税服务，指我司接受你的委托，代为办理税务申报、缴纳税款等涉税事务。这项服务旨在帮助企业及企业主减轻税务负担，提高税务合规性，避免因不熟悉税法而产生的风险。通过专业代申报，可以确保申报的准确性和及时性，为企业或个人节省时间和精力，更好地专注于自身业务发展。企业税务申报代报服务具体服务内容说明如下：
1、服务内容包括为一家个体工商户开展：客户情况分析；编制税务申报表；处理税款缴纳事务；防范税务漏报、错报风险。
2、服务期限说明：你购买的是3个月税务代申报，我们将为你申报购买当月起3个月的税务数据。如需我们帮你处理购买当月以前月份的税务申报或补报，可以联系客服另行购买服务。
3、请你注意，本协议项下的税务申报代报服务不包含以下服务：包括但不限于税务登记，税务违法的处理，欠税、偷税漏税的缴纳及罚款的缴纳，代理记账等不属于税务申报的事项。如你需要代办的可以联系客服另行购买。
（四）付款后税务服务因我司原因导致的不成功支持全额退款。你接受退款或选择继续办理则意味着你同意不追究我司因在承诺时间内未能办结的任何责任。年报报送成功或我司向你全额退款即意味着你与我司委托代理关系终止。
<p><b>五、特别说明</b></p>
(一)【委托代理】若你支付完毕服务费用，即表示你委托我司代你办理你委托的服务事宜，我司将通过网络在线方式为你提供你委托的服务。
(二)【重点说明】你知悉，按照《中华人民共和国税收征收管理法》等法规文件，税务信息申报是你的法定义务。你也知悉，通过中国税务官方网站等渠道报送税务信息是免费的，通过我司代办你需向我司支付代理服务费用。代理服务费用是我司为你提供服务而收取的服务费。代理服务费用的金额以我司通过网页向你公示的价格为准。
(三)【资料说明】你知悉，我司接受你的委托为你办理代理服务需要你按照规定提供包括但不限于法定代表人或负责人身份证、手机号、报税相关的短信验证码、财务情况、税务情况、开票情况、经营数据等资料，你应当保证资料的真实性、完整性、合法性。其中报税必须的材料应在税务法规规定的报税期限截至日提前10日提供。因你的原因无法提供或错误提供上述信息导致的后果由你自行承担。我司依据本协议，根据你企业管辖地税务监督管理部门的规定，及时为你办理代理服务。
(四)【期限要求】按照国家税务法律法规规定的期限进行服务。但因你的原因（包括但不限于无法联系、不配合提供所需信息、不配合履行报税相应流程等）导致我们无法按期完成申报的，不属于我们违约，后果和责任由你自行承担。
(五)【服务电话】我司受理你的委托后，将忠实履行代理义务。我司为你提供人工电话服务，服务电话400-188-5167你可在工作时间段（工作日的上午8:30-12:00，下午14:00-18:00）通过该电话咨询业务、了解进程、反映问题、进行投诉、反馈异议等，我是将及时进行处理。
(六)【保密措施】我司承诺,你提交的资料及填写的相关信息.我司将采取严格的保密措施仅用于办理你的委托事宜及与你本人联系。未经你同意，不向任何第三方提供。
(七)【名誉保护】在代理服务期间，如我司未违背本协议约定，你不得向任何第三方发布、提供有损我司利益、名誉的信息，否则我司有权追究你的法律责任。
(八)【用户授权】如你同意此协议，即代表你已同意接收我方推送的短信提醒或服务营销信息。
(九)【用户承诺】你应当基于合法、正当的目的使用${sign}服务平台提供的服务，不得滥用任何服务及/或信息 ，否则应自行承担相应法律责任，如由此造成${sign}服务平台损失的，用户还应当予以赔偿。
(十)本《协议》未明确列出的事项，${sign}服务平台保有最终解释权。请在使用时咨询客服。
<p><b>六、用户的违约及处理</b></p>
(一) 违约的认定：
1.使用${sign}税务申报平台服务时违反有关法律法规规定的；
2.违反本协议约定的；
3.付款后拒绝接听我司在工作时段的联系电话、拒绝接受服务、拒绝提供应当提供的报送信息、提供虚假或错误的信息。
(二)【禁止性信息】你在使用${sign}税务申报平台服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的商品、服务或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：
1.违反国家法律法规禁止性规定的；
2.政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
3.危害国家安全、泄露国家秘密的；
4.欺诈、虚假、不准确或存在误导性的；
5.侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
6.侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
7.其他违背社会公共利益或公共道德的。
(三)【违反约定】你同意保障和维护${sign}服务平台及其他用户的利益，如因你违反有关法律、法规或本《协议》项下的任何条款而给${sign}服务平台或任何其他第三者造成损失，你同意承担由此造成的损害赔偿责任。
(四)【纠纷处理】你和本平台产生纠纷的，双方应友好协商解决，协商不成的，可向潍坊高新技术产业开发区人民法院
 提起诉讼。双方同意，不以任何方式侵害对方的商誉、名誉等，否则，任何一方均可追究对方的法律责任。
<p><b>七、免责声明</b></p>
(一)我司对于下述原因导致的本合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我司无需为此承担任何责任：
1.我司已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
2.因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令、疫情等不可抗力因素。
3.基础运营商或主管部门故障、调整导致之影响。
4.因政府管制而造成的暂时性关闭、服务调整等。
<p><b>八、服务终止</b></p>
(一)【终止的情形】本服务可能会因为下述情形终止：
1.我司变更本服务内容而你明示不愿接受变更事项的。
2.服务期限届满。
3.你违反本协议约定，我司依据违约条款终止本协议的。
<p><b>九、知识产权</b></p>
(一)你不得恶意申请和注册与我司相同或近似的商标、名称、标识、标志、微信公众号、域名、网页等，用于开展与我司实质相同或近似的业务。
<p><b>十、通知与送达</b></p>
(一)【通知实时关注】我司根据你提供的任一联系方式送达各类通知，而此类通知的内容可能对你的权利义务产生重大的有利或不利影响，请你务必及时关注。
(二)【通知的送达】本协议签订或履行过程中，我司向你通过书面形式发送通知，书面通知形式包括但不限于向你发送电子邮件、手机短信、微信消息和传真等电子方式，在采用电子方式进行通知的情况下，发送当日即视为送达。
(三)【联系方式实时更新】你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不正确，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由你自行承担由此可能产生的法律后果。
    </p>
    `
}
